import { IRequest } from 'legacy/lut/classes/models/onboarding/IRequest'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { IOnboardingState } from './models'

export const initialProcessProgressData: IObjectAny[] = [{}]

const getInitialProfilingProgressData = () => ({
  data: null,
  status: RequestStatus.FULFILLED,
  message: '',
})

const getInitialLRProgressData = () => ({
  data: null,
  status: RequestStatus.FULFILLED,
  message: '',
})

const getInitialContractSignatureProgressData = () => ({
  data: null,
  status: RequestStatus.FULFILLED,
  message: '',
})

export const getInitialOnboardingState = (): IOnboardingState => ({
  requestData: {
    data: {} as IRequest,
    status: RequestStatus.FULFILLED,
    message: '',
  },

  progressData: {
    profilingProgressData: getInitialProfilingProgressData(),
    lrProgressData: getInitialLRProgressData(),
    contractSignatureProgressData: getInitialContractSignatureProgressData(),
  },

  childrenRequestsData: {
    data: [],
    status: RequestStatus.FULFILLED,
    message: '',
  },

  parentRequestData: {
    data: null,
    status: RequestStatus.FULFILLED,
    message: '',
  },

  actionsData: {
    data: [],
    status: RequestStatus.FULFILLED,
    message: '',
  },

  actionTransitionsData: {
    data: [],
    status: RequestStatus.FULFILLED,
    message: '',
  },

  processesProgressData: {
    data: initialProcessProgressData,
    status: RequestStatus.FULFILLED,
    message: '',
  },

  requestTemplateData: {
    data: null,
    status: RequestStatus.FULFILLED,
    message: '',
  },

  commonData: {
    isDataUploadedForTransitionsMapping: false,
    contactsWithMultiplePartners: {
      data: [],
      status: RequestStatus.FULFILLED,
      message: '',
    },
    refreshContactDataTrigger: false,
  },

  executableTransitionData: {
    data: {},
    status: RequestStatus.FULFILLED,
    message: '',
  },
})

export const GET_ACTIONS_DATA = 'onboarding/fetchActionsData'
export const GET_PARENT_ACTIONS_DATA = 'onboarding/fetchParentActionsData'
export const GET_REQUEST_DATA = 'onboarding/fetchRequestData'
export const GET_PARENT_REQUEST_DATA = 'onboarding/fetchParentRequestData'
export const GET_ACTION_TRANSITIONS_DATA = 'onboarding/fetchActionTransitionData'
export const GET_EXECUTABLE_TRANSITION_DATA = 'onboarding/executableTransitionData'
export const GET_PROCESS_PROGRESS_DATA = 'onboarding/fetchProcessProgressData'
export const GET_REQUEST_TEMPLATE_DATA = 'onboarding/fetchRequestTemplateData'
export const GET_REQUEST_TEMPLATE_BY_REQUEST_ID = 'onboarding/fetchRequestTemplateByRequestId'
export const GET_CHILDREN_REQUESTS_DATA = 'onboarding/fetchChildrenRequestsData'
export const REFRESH_ACTION_REQUEST = 'onboarding/refreshActionRequest'
export const REFRESH_ACTION_TRANSITIONS = 'onboarding/refreshActionTransitions'
export const CHANGE_ACTION_SELECTED_USERS = 'onboarding/changeActionSelectedUsers'
export const GET_CONTACTS_WITH_MULTIPLE_PARTNER_DATA = 'onboarding/getContactsWithMultiplePartners'
export const REFRESH_CONTACT_DATA = 'onboarding/refreshContactData'

// ProgressData
export const GET_PROFILING_PROGRESS_DATA = 'onboarding/fetchProfilingProgressData'
export const GET_LR_PROGRESS_DATA = 'onboarding/fetchLRProgressData'
export const GET_CONTRACT_SIGNATURE_PROGRESS_DATA = 'onboarding/fetchContractSignatureProgressData'
export const REFRESH_PROFILING_PROGRESS_DATA = 'onboarding/refreshProfilingProgressData'
export const REFRESH_LR_PROGRESS_DATA = 'onboarding/refreshLRProgressData'
export const REFRESH_CONTRACT_SIGNATURE_PROGRESS_DATA =
  'onboarding/refreshContractSignatureProgressData'

export const GET_ONBOARDING_PARTNER_BY_ID_REQUEST = 'partner/getOnboardingPartnerById'
export const GET_ONBOARDING_NEW_PARTNER_BY_ID_REQUEST = 'partner/getOnboardingNewPartnerById'
